/**
 * Umožňuje uchovávat uživatelská data uložená v lokálním uložišti.
 * Toto úložiště je sdílené mezi okny ze stejné domény.
 * Trvalost těchto dat není zajištěna, jelikož je uživatel nebo systém může kdykoliv smazat.
 */
export class ApplicationStorage {
    /**
     * Uloží hodnotu pod daný klíč
     * @param key Klíč
     * @param value Nová hodnota
     */
    public static set(key: AppStorageItemType | string, value: string): void {
        localStorage.setItem(key, value);
    }

    /**
     * Vrátí hodnotu daného klíče
     * @param key Klíč
     */
    public static get(key: AppStorageItemType | string): string | null {
        return localStorage.getItem(key);
    }

    /**
     * Vymaže hodnotu daného klíče
     * @param key Klíč
     */
    public static remove(key: AppStorageItemType | string): void {
        localStorage.removeItem(key);
    }
}

// !!! hodnoty enumů se nesmí změnit, protože pod nimi jsou uloženy hodnoty ve storage a rozbilo by se všechno nastavení uživatele
export enum AppStorageItemType {
    reportLanguage = "ReportLanguage",
    reportType = "ReportType",
    winAuthUsed = "WinAuthUsed",
    userTheme = "UserTheme",
    language = "Language",
}
